<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="modalContainerClassList">
          <div v-if="closable" class="modal-close text-xs-right">
            <v-btn
              color="grey"
              large
              flat
              icon
              @click="$emit('close')">
              <v-icon large>highlight_off</v-icon>
            </v-btn>
          </div>
          <div v-if="title" class="modal-header">
            <h3 class="header">{{ title }}</h3>
          </div>
          <!-- <div class="modal-body" :class="modalBodyClassList"> -->
          <slot />
          <!-- </div> -->
          <div class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    closable: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    shouldLimitHeight: {
      type: Boolean,
      default: true,
    },
    shouldNotHavePadding: {
      type: Boolean,
      default: false,
    },
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    isSlender: {
      type: Boolean,
      default: false,
    },
    isWide: {
      type: Boolean,
      default: false,
    },
    isFixedHeight: {
      type: Boolean,
      default: false,
    },
    modalSize: {
      type: String,
      default: 'slender',
    },
  },
  computed: {
    modalBodyClassList() {
      return {
        'limit-height': this.shouldLimitHeight,
      };
    },
    modalContainerClassList() {
      return {
        'remove-padding': this.shouldNotHavePadding,
        'dark-mode': this.isDarkMode,
        'modal-size--slender': this.modalSize === 'slender',
        'modal-size--dual-pane': this.modalSize === 'dual-pane',
        'modal-size--legacy': this.modalSize === 'legacy',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins';
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.modal {
  &-body {
    &.limit-height {
      max-height: 450px;
    }
    flex-grow: 2;
  }
  &-footer {
    position: sticky;
    bottom: 0;
    height: auto;
  }

  &-close {
    position: absolute;
    right: 18px;
    top: 8px;
  }

  &-container {
    &.modal-size--legacy,
    &.modal-size--dual-pane,
    &.modal-size--slender {
        max-height: 90vh;
        max-width: 90vw;
    }

    &.modal-size--legacy {
      @include large-viewport {
        height: 600px;
        max-width: 600px;
      }
      @include small-viewport {
        width: 90vw;
        height: 90vh;
      }
    }

    &.modal-size--dual-pane {
      height: 650px;
      max-height: 650px;
      max-height: 90vh;
      width: 880px;
      @include small-viewport {
        width: 440px;
        max-width: 90vw;
      }
    }

    &.modal-size--slender {
      width: 400px;
      @include small-viewport {
        width: 440px;
        max-height: 90vh;
        max-width: 90vw;
      }
    }

    background: white;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    margin: 0 auto;

    &.dark-mode {
      background-color: $theme-color-darkest-gray;
      color: $theme-color-white;
    }
    &.orientation--portrait {
      width: 300px;
    }
    &.remove-padding {
      padding: 0;
    }
    &.slender {
      @include large-viewport {
        max-width: 400px;
        width: 400px;
      }
    }
  }

  &-mask {
    background-color: rgba($theme-color-black, 0.5);
    display: table;
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    transition: opacity 0.3s ease;
    width: 100%;
    z-index: 9998;
  }

  &-wrapper {
    display: table-cell;
    vertical-align: middle;
  }
}

.header {
  border-bottom: solid 3px $theme-color-primary;
  margin-bottom: 30px;
  padding-bottom: 20px;
}
</style>
